export var RenderOrder;
(function (RenderOrder) {
    RenderOrder[RenderOrder["SKY_BOX"] = -3] = "SKY_BOX";
    RenderOrder[RenderOrder["INFINITE_PLANE"] = -2] = "INFINITE_PLANE";
    RenderOrder[RenderOrder["GROUND_PLANE"] = -1] = "GROUND_PLANE";
    RenderOrder[RenderOrder["OPAQUE_GEOMETRY"] = 0] = "OPAQUE_GEOMETRY";
    RenderOrder[RenderOrder["LINES"] = 1] = "LINES";
    RenderOrder[RenderOrder["TRANSPARENT_GEOMETRY"] = 2] = "TRANSPARENT_GEOMETRY";
    RenderOrder[RenderOrder["TOOLTIP_BACKGROUND"] = 3] = "TOOLTIP_BACKGROUND";
    RenderOrder[RenderOrder["TOOLTIP_TEXT"] = 4] = "TOOLTIP_TEXT";
    RenderOrder[RenderOrder["LASER"] = 5] = "LASER";
    RenderOrder[RenderOrder["MOVE_DATA_SELECTION_FILTER"] = 6] = "MOVE_DATA_SELECTION_FILTER";
    RenderOrder[RenderOrder["AFTER_SELECTION"] = 7] = "AFTER_SELECTION";
    RenderOrder[RenderOrder["MARKER_DISK"] = 8] = "MARKER_DISK";
    RenderOrder[RenderOrder["VIEW_TO_TEXTURE"] = 9] = "VIEW_TO_TEXTURE";
    RenderOrder[RenderOrder["UI_ELEMENTS"] = 10] = "UI_ELEMENTS";
    RenderOrder[RenderOrder["HUD_IMAGE_ELEMENTS"] = 11] = "HUD_IMAGE_ELEMENTS";
    RenderOrder[RenderOrder["HUD_MARKER_ELEMENTS"] = 12] = "HUD_MARKER_ELEMENTS";
    RenderOrder[RenderOrder["HUD_TEXT_ELEMENTS"] = 13] = "HUD_TEXT_ELEMENTS";
})(RenderOrder || (RenderOrder = {}));
export var Layer;
(function (Layer) {
    Layer[Layer["CAMERA_LAYER_VIDEO_TEXTURE_TARGET"] = 6] = "CAMERA_LAYER_VIDEO_TEXTURE_TARGET";
})(Layer || (Layer = {}));
